import { render, staticRenderFns } from "./PlatformSidebar.vue?vue&type=template&id=2b7defbd&scoped=true"
import script from "./PlatformSidebar.vue?vue&type=script&lang=ts"
export * from "./PlatformSidebar.vue?vue&type=script&lang=ts"
import style0 from "./PlatformSidebar.vue?vue&type=style&index=0&id=2b7defbd&prod&lang=scss&scoped=scoped"
import style1 from "./PlatformSidebar.vue?vue&type=style&index=1&id=2b7defbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7defbd",
  null
  
)

export default component.exports